import { Offer } from 'app/services/offers/offer.model';
import { DeclineReason } from 'ng2-app/models/dto/decline-reason.model';

export class GetDealOffers {
	static readonly type = '[Offer] GetDealOffers';
	constructor(public borrowerId: number, public refresh?: boolean) {}
}

export class DeleteOffer {
	static readonly type = '[Offer] DeleteOffer';
	constructor(public offerId: number) {}
}

export class UpdateOffer {
	static readonly type = '[Offer] UpdateOffer';
	constructor(public offerId: number, public updates: any) {}
}

export class CreateOffer {
	static readonly type = '[Offer] CreateOffer';
	constructor(public offer: Offer) {}
}

export class PublishOffer {
	static readonly type = '[Offer] PublishOffer';
	constructor(public offerId: number, public userId: number, public publishedToBorrower: number) {}
}

export class RemoveFromPortal {
  static readonly type = '[Offer] RemoveFromPortal';
  constructor(public offerId: number) {}
}

export class ToggleOffer {
	static readonly type = '[Offer] ToggleOffer';
	constructor(public offerId: number) {}
}

export class ClearOfferStore {
	static readonly type = '[Offer] ClearOfferStore';
	constructor() {}
}

export class ClearOfferError {
	static readonly type = '[Offer] ClearOfferError';
	constructor() {}
}

export class AttachValuePropsToOffer {
  static readonly type = '[Offer] AttachValuePropsToOffer';
  constructor(public offerId: number, public valuePropositionIds: number[]) {}
}

export class AttachDeclineReasonsToOffer {
  static readonly type = '[Offer] AttachDeclineReasonsToOffer';
  constructor(public offerId: number, public declineReasons: Pick<DeclineReason, 'id' | 'comment'>[]) {}
}

export class RecommendOffer {
  static readonly type = '[Offer] RecommendOffer';
  constructor(
    public offerId: number,
    public recommend: boolean,
  ) {}
}

export class ResetRecommendedFlagOffers {
  static readonly type = '[Offer] ResetRecommendedFlagOffers';
  constructor(
    public offerIds: number[],
  ) {}
}

